import { render, staticRenderFns } from "./processing-requests-confirmation.view.vue?vue&type=template&id=74413464&"
import script from "./processing-requests-confirmation.view.vue?vue&type=script&lang=ts&"
export * from "./processing-requests-confirmation.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports